<div class="backgroundDark">
    <h2 mat-dialog-title class="marginBottom0" fxFlex>Save Changes</h2>
</div>

<mat-dialog-content style="max-height: 95%; padding: 0 !important;">
    <div class="unsavedChangesText">You have made changes that haven't been saved yet.<br/><br/> Are you sure you would like to quit without your changes being saved?</div>
</mat-dialog-content>
<mat-dialog-actions fxLayoutAlign="end center">   
    <button mat-button matDialogClose="cancel" class="mat-raised-button dialogActionButton">No</button>
    <button mat-button matDialogClose="confirm" color="primary" class="mat-raised-button dialogActionButton">Yes</button>
</mat-dialog-actions>
